/**
 * Centralized API configuration. All env-derived URLs and settings live here.
 *
 * - Default: live production API (mobile release builds and `npm run build`)
 * - `npm run dev` → `.env.development` overrides to Pantheon dev
 * - Override any time via `VITE_API_BASE_URL` in `.env` or build env
 */
const raw = import.meta.env.VITE_API_BASE_URL as string | undefined;
const defaultBase = "https://miningmatters.co/api/";

export const API_BASE_URL = raw?.trim() || defaultBase;
export const API_ORIGIN = new URL(API_BASE_URL).origin;
